export const noop = (): undefined => {
  return undefined;
};
